// extracted by mini-css-extract-plugin
export default {"ideation":"Ideation_ideation__VV4eO","ideationImage":"Ideation_ideationImage__3GMf1"};